import React, { Component, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Input,
  message,
  Avatar,
  Tooltip,
  Card,
  Spin,
  Layout,
  Result,
  PageHeader,
  Image,
  Typography,
} from "antd";
import {
  EditOutlined,
  FolderOpenOutlined,
  FontColorsOutlined,
  UserOutlined,
  AntDesignOutlined,
} from "@ant-design/icons";
import map from "lodash/map";
import { fetchFolders, changeFolderTitle } from "../../actions/workbookActions";
import CustomScrollbars from "../../utils/CustomScrollbars";
import Auxiliary from "../../utils/Auxiliary";

import NewLecture from "../misc/newLecture/NewLecture";
import { FormattedMessage } from "react-intl";
import messages from "../../messages";
// import Joyride from "react-joyride";
import _ from "lodash";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GreenStepItem = ({ data }) => {
  const { name, subject, description, created_at } = data;
  return (
    <Auxiliary>
      <Typography.Title level={5} ellipsis>
        {name || " "}
      </Typography.Title>
      <Typography.Text type="secondary" ellipsis className="gx-mb-3">
        {subject || " "}
      </Typography.Text>
      {/* <h2 className="h3 gx-mb-2"></h2>
      <p className="gx-text-grey"></p> */}
      {/* <p>{description}</p> */}
    </Auxiliary>
  );
};

const GreenStepCard = ({ slide, onOpen, onRename, folder }) => {
  const [image, setImage] = useState(
    slide[0]?.slide[0]?.thumbnail || `images/build-lecture.png`
  );
  const [loading, setLoading] = useState(false);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 800,
    marginLeft: 10,
    marginRight: 10,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
  };
  return (
    <Card
      bodyStyle={{ height: "100%" }}
      className="gx-card-widget gx-card-full"
    >
      <span className="gx-widget-badge">{folder}</span>
      <Row className="gx-h-100">
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <div className="gx-slick-slider-lt-thumb">
            <img
              className={
                loading
                  ? "fadeout gx-img-fluid gx-mh300"
                  : "fadein gx-img-fluid gx-mh300"
              }
              src={image}
              alt={slide.name}
              onError={(e) => (
                (e.target.onerror = null),
                (e.target.src = `images/build-lecture.png`)
              )}
              // fallback="data:image/png;base64,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"
            />
          </div>
        </Col>
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <Slider
            className="gx-slick-slider gx-slick-slider-dot-top"
            {...settings}
            afterChange={(index) => {
              setLoading(false);
              setImage(slide[index]?.slide[index]?.thumbnail);
            }}
            beforeChange={(oldIndex, newIndex) => {
              setLoading(true);
            }}
          >
            {slide.length ? (
              slide.map((data, index) => (
                <GreenStepItem key={index} data={data} />
              ))
            ) : (
              <GreenStepItem key={1} data={{}} />
            )}
          </Slider>
          {/* <Button.Group> */}
          <div>
            <Button
              icon={<FolderOpenOutlined className="gx-fs-xl" />}
              shape="circle"
              onClick={() => onOpen()}
              type="primary"
            />
            <Button
              icon={<EditOutlined className="gx-fs-xl" />}
              shape="circle"
              onClick={() => onRename()}
              type="primary"
            />
          </div>

          {/* <Button onClick={() => {}} type="primary">
            Rename
          </Button> */}
          {/* </Button.Group> */}
        </Col>
      </Row>
    </Card>
  );
};

class DashboardPage extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      folders: [],
      errors: {},
      folderSearchText: "",
      editPopup: false,
      oldTitle: "",
      newTitle: "",
      isLoading: false,
      workbookType: "workbook",
      lecture: false,
      isTourOpen: false,
      tourSteps: [
        {
          target: "#root > div > section > section > main > div > main > div",
          content: "Click here to create a new workbook",
        },
        {
          target:
            "#root > div > section > section > main > div > div:nth-child(1) > div:nth-child(1) > div > div:nth-child(1)",
          content: "Hover to open folder or to remain it.",
        },
        {
          target: "#root > div > section > section > main > header > ul > div",
          content: "Click or Hover here for more actions",
        },
        {
          target:
            "#root > div > section > section > main > header > div.gx-linebar.gx-mr-3 > div > div:nth-child(1)",
          content: "Click here for more actions",
        },
        {
          target:
            "#root > div > section > section > main > header > div.gx-linebar.gx-ml-3.gx-pointer",
          content: "Click here to logout",
        },
        {
          target:
            "#root > div > section > section > main > footer > div > span",
          content: "Change language from here",
        },
      ],
    };
  }

  initJssorSlider = (sliderId) => {
    var jssor_1_options = {
      $AutoPlay: 1,
      $Idle: 0,
      $SlideDuration: 4000,
      $SlideEasing: $Jease$.$Linear,
      $PauseOnHover: 0,
      $SlideWidth: 550,
      $Align: 0,
    };

    var sliderIdSlider = new $JssorSlider$(sliderId, jssor_1_options);

    var MAX_WIDTH = 980;

    function ScaleSlider() {
      var containerElement = sliderIdSlider.$Elmt.parentNode;
      var containerWidth = containerElement.clientWidth;
      if (containerWidth) {
        // var expectedWidth = Math.min(
        //   MAX_WIDTH || containerWidth,
        //   containerWidth
        // );
        // sliderIdSlider.$ScaleWidth(expectedWidth);
      } else {
        window.setTimeout(ScaleSlider, 30);
      }
    }

    ScaleSlider();

    $Jssor$.$AddEvent(window, "load", ScaleSlider);
    $Jssor$.$AddEvent(window, "resize", ScaleSlider);
    $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
  };

  componentDidMount = () => {
    this.getFolderList();
  };

  getFolderList = () => {
    fetchFolders()
      .then((res) => {
        this.setState({ folders: res.data.folders }, () => {
          // setTimeout(() => {
          //   for (const item in this.state.folders) {
          //     this.initJssorSlider(`jssor_${item}`);
          //   }
          // }, 2000);
        });
      })
      .catch((error) => {
        console.log("DashboardPage -> error", error);
        message.error("Error while fetching folder, Please try again.");
      });
  };

  onFinish = async (values) => {
    try {
      await changeFolderTitle({ oldTitle: this.state.oldTitle, ...values });
      this.setState({ editPopup: !this.state.editPopup }, () => {
        this.getFolderList();
        message.success("Folder name updated successfully.");
      });
    } catch (error) {
      console.log("DashboardPage -> error", error);
      message.error("Error while updating the name, Please try again.");
    }
  };

  toggleLecture = (property) => {
    this.setState({ lecture: !this.state.lecture, workbookType: property });
  };
  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  render() {
    const { folders, errors, isTourOpen } = this.state;

    return (
      <>
        {!_.size(folders) ? (
          <Layout.Content
            style={{
              minHeight: "calc(100% - 192px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Result
              className="gx-p-0 gx-empty-holder-frame gx-pointer"
              icon={
                <>
                  <figure onClick={() => this.toggleLecture("workbook")}>
                    <img src={"images/old_icons/new_lecture.png"} />
                  </figure>

                  <span>
                    Contribute Cloud everyday helps us collaborate, cast and
                    play
                  </span>
                </>
              }
            />
          </Layout.Content>
        ) : (
          <CustomScrollbars className="gx-content-scroll gx-text-center">
            <PageHeader
              className="gx-mb-4"
              ghost={false}
              title={`Workbook folders`}
              extra={[
                <Button
                  onClick={() => this.toggleLecture("workbook")}
                  type="primary"
                >
                  Create New Workbook
                </Button>,
                <Input.Search
                  style={{ width: 300 }}
                  placeholder="Search folder"
                  allowClear
                  onChange={(ev) =>
                    this.setState({ folderSearchText: ev.target.value })
                  }
                  onSearch={(value) =>
                    this.setState({ folderSearchText: value })
                  }
                />,
              ]}
            />
            <div className="gx-card-list">
              {map(folders, (folder, key) => (
                <GreenStepCard
                  onOpen={() =>
                    this.context.router.push(
                      `/dashboard?folder=${encodeURIComponent(key)}`
                    )
                  }
                  onRename={() => {
                    this.setState({
                      editPopup: !this.state.editPopup,
                      oldTitle: key,
                      newTitle: key,
                    });
                  }}
                  slide={folder}
                  folder={key}
                />
              ))}
            </div>
            {/* <div className="gx-card-list">
              {map(folders, (folder, key) => {
                if (
                  !this.state.folderSearchText ||
                  (this.state.folderSearchText &&
                    key
                      .toLocaleLowerCase()
                      .indexOf(this.state.folderSearchText.toLowerCase()) > -1)
                ) {
                  return (
                    <div className="gx-card-item">
                      <div className="gx-card">
                        <div className="gx-card-actions">
                          <Tooltip title="Rename Folder" placement="top">
                            <FontColorsOutlined
                              onClick={() =>
                                this.setState({
                                  editPopup: !this.state.editPopup,
                                  oldTitle: key,
                                  newTitle: key,
                                })
                              }
                              className="gx-mx-3"
                            />
                          </Tooltip>

                          <Tooltip title="Open Folder" placement="top">
                            <FolderOpenOutlined
                              onClick={() =>
                                this.context.router.push(
                                  `/dashboard?folder=${key}`
                                )
                              }
                              className="gx-mx-3"
                            />
                          </Tooltip>
                        </div>
                        {!folder?.length ? (
                          <div className="gx-card-body">
                            <figure
                              style={{
                                backgroundImage: `url(${"images/build-lecture.png"})`,
                                backgroundSize: "cover",
                                backgroundPosition: "50% 50%",
                                backgroundRepeat: "no-repeat",
                              }}
                            />
                          </div>
                        ) : (
                          <div className="gx-card-body-slider">
                            <figure
                              id={`jssor_${key}`}
                              style={{
                                position: "relative",
                                margin: "0 auto",
                                top: 0,
                                left: 0,
                                width: 980,
                                height: 300,
                                overflow: "hidden",
                                visibility: "hidden",
                              }}
                            >
                              <div
                                data-u="slides"
                                style={{
                                  cursor: "default",
                                  position: "relative",
                                  top: 0,
                                  left: 0,
                                  width: 980,
                                  height: 300,
                                  overflow: "hidden",
                                }}
                              >
                                {map(folder, (item) => (
                                  <div>
                                    <img data-u="image" src={item} />
                                  </div>
                                ))}
                              </div>
                            </figure>
                          </div>
                        )}

                        <div className="gx-card-foot">
                          <Card.Meta
                            title={
                              <>
                                <FolderOpenOutlined className="gx-mx-3" />
                                {key}
                              </>
                            }
                            description={<></>}
                          />
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div> */}

            <Modal
              title="Change Folder Name"
              visible={this.state.editPopup}
              okText={"Save"}
              okButtonProps={{
                form: "changeFolderName",
                key: "submit",
                htmlType: "submit",
                size: "large",
              }}
              onCancel={() =>
                this.setState({ editPopup: !this.state.editPopup })
              }
              cancelButtonProps={{
                size: "large",
              }}
            >
              <Form
                name="changeFolderName"
                size="large"
                initialValues={{ newTitle: this.state.newTitle }}
                onFinish={this.onFinish}
              >
                {errors.form && <Alert message={errors.form} type="error" />}

                <Form.Item
                  name="newTitle"
                  {...(errors.title && {
                    help: errors.title,
                    validateStatus: "error",
                  })}
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                >
                  <Input placeholder="Folder name" />
                </Form.Item>
              </Form>
            </Modal>
          </CustomScrollbars>
        )}
        <NewLecture
          visible={this.state.lecture}
          toggleModal={this.toggleLecture}
          workbookType={this.state.workbookType}
          title={
            this.state.workbookType == "workbook" ? (
              <FormattedMessage {...messages.createNewWorkbook} />
            ) : (
              <FormattedMessage {...messages.startNewLecture} />
            )
          }
        />
        {/* {isTourOpen && <Joyride steps={this.state.tourSteps} />}
        <Button
          style={{ position: "absolute", left: 20, bottom: 50 }}
          type="primary"
          shape="circle"
          onClick={this.openTour}
        >
          H
        </Button> */}
      </>
    );
  }
}

DashboardPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(null, {})(DashboardPage);
